import { useDocumentInstance } from 'bridge';
import { Conversation } from 'business';

export default function useConversation(conversationId?: string) : Conversation | null | undefined {
    return useDocumentInstance('conversations', conversationId);
}
